import { render, staticRenderFns } from "./TooltipTag.vue?vue&type=template&id=cc846972&scoped=true&"
import script from "./TooltipTag.vue?vue&type=script&lang=js&"
export * from "./TooltipTag.vue?vue&type=script&lang=js&"
import style0 from "./TooltipTag.vue?vue&type=style&index=0&id=cc846972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc846972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc846972')) {
      api.createRecord('cc846972', component.options)
    } else {
      api.reload('cc846972', component.options)
    }
    module.hot.accept("./TooltipTag.vue?vue&type=template&id=cc846972&scoped=true&", function () {
      api.rerender('cc846972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TooltipTag.vue"
export default component.exports